import { AfterViewInit, Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MethodeDTO, MethodeService } from '../../../services/methode-service/methode.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, NgIf } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormGroup, Validators, FormArray, FormBuilder, AbstractControl } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOption, MatOptionModule } from '@angular/material/core';
import {ChangeDetectorRef} from '@angular/core';
import {
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerModule,
    MatDatepickerToggle
} from "@angular/material/datepicker";import { MatExpansionModule, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { MatFormFieldModule, MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { MethodStepDTO } from '../../_models/method-step.dto';
import { MethodeStepService } from '../../../services/methodeS-service/methodeS.service';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { MatIcon } from "@angular/material/icon";
import { DialogService } from '../../_modal/dialog.service';
@Component({
  selector: 'app-methode',
  standalone: true,
imports: [MatExpansionModule, MatRadioModule,
    MatNativeDateModule,
    CommonModule, MatOption, MatExpansionModule,
    MatNativeDateModule,
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule, MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    OverlayModule,
    MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,
    MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatCheckbox, MatProgressSpinner, MatTab, MatTabGroup, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription,
    MatCardModule, MatMenuModule, MatButtonModule, MatButtonToggleModule, MatTableModule, MatPaginatorModule, NgIf,
    MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatChipsModule, MatSlideToggleModule,
    MatSuffix, MatSortModule, MatInputModule, MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatCheckbox, MatIcon],
   
  templateUrl: './methode.component.html',
  styleUrls: ['./methode.component.scss']
})

export class MethodeComponent implements OnInit, AfterViewInit {
getStepTitleById(id: number): string {
  const step = this.methodSteps.find(s => s.id === id);
  return step ? step.titre : '';
}

toggleStepSelectionCheckbox(stepId: number, event: Event) {
  const control = this.form.get('stepIds');
  if (!control) return;

  const isChecked = (event.target as HTMLInputElement).checked;

  let selectedIds: number[] = control.value || [];

  if (isChecked) {
    if (!selectedIds.includes(stepId)) {
      selectedIds.push(stepId);
    }
  } else {
    selectedIds = selectedIds.filter(id => id !== stepId);
  }

  control.setValue(selectedIds);
}


viewStep(_t313: any) {
throw new Error('Method not implemented.');
}
editStep(_t313: any) {
throw new Error('Method not implemented.');
}
deleteStep(_t313: any) {
throw new Error('Method not implemented.');
}

  dataSource = new MatTableDataSource<MethodeDTO>();
  loadingTable = false;
displayedColumns: string[] = [
  'select',
  'code',
  'name',
  'norme',
  //'stepsCount',
  //'versionsCount',
  'action'
];
@ViewChildren(MatDatepicker) pickers!: QueryList<MatDatepicker<any>>;
  getPicker(i: number): MatDatepicker<any> | undefined {
    return this.pickers.toArray()[i];
  }
  form!: FormGroup;
  methodSteps: MethodStepDTO[] = [];
  toggleSelectAll() {
    if (this.isAllStepsSelected) this.selectedSteps = [];
    else this.selectedSteps = [...this.dataSource.data];
    this.isAllStepsSelected = !this.isAllStepsSelected;
  }
selectedSteps: MethodeDTO[] = [];
  isAllStepsSelected = false;
    toggleSelection(step: MethodeDTO) {
      const index = this.selectedSteps.indexOf(step);
      if (index === -1) this.selectedSteps.push(step);
      else this.selectedSteps.splice(index, 1);
    }


// Pour gérer l'ouverture du dropdown pour chaque version
versionDropdownState: boolean[] = [];

// Lors de l'initialisation ou à chaque ajout de version
initializeVersionDropdownState() {
  this.versionDropdownState = this.versions.controls.map(() => false);
}

// Etat d'ouverture du dropdown pour chaque version

toggleVersionDropdown(index: number) {
  this.versionDropdownState[index] = !this.versionDropdownState[index];
}

// Retourne le titre des étapes sélectionnées sous forme de texte pour l'input
getSelectedStepTitles(ids: number[] = []): string {
  if (!ids || ids.length === 0) return '';
  return ids
    .map(id => this.getStepTitleById(id))
    .join(', ');
}
toggleStepSelection(stepId: number, control: any) {
  const current = control.value || [];

  if (current.includes(stepId)) {
    control.setValue(current.filter((id: number) => id !== stepId));
  } else {
    control.setValue([...current, stepId]);
  }
}
// Etat d'ouverture du dropdown pour main steps
mainStepsDropdownState = false;

toggleMainStepsDropdown() {
  this.mainStepsDropdownState = !this.mainStepsDropdownState;
}

// Reutilise cette fonction pour afficher le texte sélectionné dans l'input


toggleStepSelectionCheckbox1(stepId: number, event: Event, control?: AbstractControl | null) {
  if (!control) {
    // Si pas fourni, on prend le stepIds principal
    control = this.form.get('stepIds');
  }

  if (!control) return;

  const isChecked = (event.target as HTMLInputElement).checked;

  console.log(`📝 Toggle step ${stepId}, checked=${isChecked}`, control.value);

  let selectedIds: number[] = control.value || [];

  if (isChecked) {
    if (!selectedIds.includes(stepId)) {
      selectedIds.push(stepId);
    }
  } else {
    selectedIds = selectedIds.filter(id => id !== stepId);
  }

  control.setValue(selectedIds);

  console.log('🔹 Nouvelle valeur du control:', control.value);
}

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('content') content!: TemplateRef<any>;


  constructor(
    private fb: FormBuilder,
    private methodeService: MethodeService,
    private methodStepService: MethodeStepService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private dialogService:DialogService,
    public themeService: CustomizerSettingsService
  ) { }

  ngOnInit(): void {
    this.initializeForm();
    this.fetchMethodes();
    this.fetchMethodSteps();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /** Initialise le formulaire */
  initializeForm() {
      this.form = this.fb.group({
          id: [''],
          code: ['', Validators.required],
          name: ['', Validators.required],
          norme: [''],
          stepIds: [[]], // 🔹 renommer pour correspondre au template
          versions: this.fb.array([this.createVersionGroup()])
        });

    console.log('Form controls:', this.form.controls);
  }

  /** Getter pour versions FormArray */
  get versions(): FormArray {
    return this.form.get('versions') as FormArray;
  }

  /** Crée un FormGroup pour une version */
  createVersionGroup(): FormGroup {
    return this.fb.group({
      id: [''],
      numero: [1, Validators.required],
      description: [''],
      dateEdition: [''],
      stepIds: [[]] // Steps sélectionnés pour cette version
    });
  }

  /** Ajouter une nouvelle version */
  addVersion() {
    this.versions.push(this.createVersionGroup());
  }

  /** Supprimer une version */
  removeVersion(index: number) {
    this.versions.removeAt(index);
  }

  /** Ouvrir modal création/édition */



  /** Récupérer toutes les méthodes pour la table */
  fetchMethodes(): void {
    this.loadingTable = true;
    this.methodeService.getAllMethodes().subscribe({
      next: (methodes) => {
        // Assurer que steps et versions ne sont pas null
        methodes.forEach(m => {
          m.stepIds = m.stepIds || [];
          m.versions = m.versions || [];
        });
        this.dataSource.data = methodes;
        this.loadingTable = false;
      },
      error: (err) => {
        console.error('Erreur lors de la récupération des Méthodes', err);
        this.loadingTable = false;
      }
    });
  }

  /** Récupérer tous les MethodSteps pour les selects */
fetchMethodSteps() {
  console.log('🌀 Début récupération des MethodSteps...');
  this.methodStepService.getAllMethodSteps().subscribe({
    next: (steps) => {
      console.log(`✅ MethodSteps reçus: ${steps.length}`);
      console.log('📦 Contenu des MethodSteps:', steps);

      if (!steps || steps.length === 0) {
        console.warn('⚠️ Aucun MethodStep disponible !');
      }

      // Vérification rapide que chaque step a bien un id et un titre
      steps.forEach(s => {
        if (s.id == null) console.warn('⚠️ Step sans ID:', s);
        if (!s.titre) console.warn('⚠️ Step sans titre:', s);
      });

      this.methodSteps = steps;
      this.cdr.detectChanges(); // uncomment if needed
    },
    error: (err) => {
      console.error('❌ Erreur lors de la récupération des MethodSteps', err);
    }
  });
}

openCreateModal(content: any) {
  // Réinitialiser le formulaire
  this.form.reset();
  this.initializeForm();

  // Récupérer les steps (subscribe déjà géré dans fetchMethodSteps)
  this.fetchMethodSteps();

  // ouvrir le modal directement, Angular va mettre à jour le select grâce au binding
  this.modalService.open(content, {
    ariaLabelledBy: 'modal-basic-title',
    size: 'xl',
    backdrop: true,
    keyboard: true
  });

  console.log('Modal ouvert avec form:', this.form.value);
}


  /** Filtrer la table */
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  /** Voir méthode */
  viewMethode(methode: MethodeDTO) {
    console.log('Voir méthode :', methode);
    // ouvrir modal si besoin
  }

  @ViewChild('editModal') editModal: TemplateRef<any>;
saveEditedMethode() {
  console.group('🚀 saveEditedMethode()');

  if (this.form.invalid) {
    console.error('❌ Formulaire invalide', this.form);
    console.groupEnd();
    return;
  }

  // Construire le DTO à envoyer
  const dto: MethodeDTO = {
    id: this.form.value.id,
    code: this.form.value.code,
    name: this.form.value.name,
    norme: this.form.value.norme,
    stepIds: this.form.value.stepIds ?? [],

    versions: (this.form.value.versions || []).map((v: any, i: number) => ({
      id: v.id || null,
      numero: v.numero || i + 1, // 🔹 numéro automatique si vide
      description: v.description,
      dateEdition: v.dateEdition,
      stepIds: v.stepIds ?? []
    }))
  };

  console.log('📤 DTO envoyé pour update :', dto);

  // Appel du backend via le service
  this.methodeService.updateMethode(dto).subscribe({
    next: (res) => {
      console.log('✅ Méthode mise à jour :', res);
      this.modalService.dismissAll();
      this.fetchMethodes(); // rafraîchir la liste
    },
    error: (err) => {
      console.error('🔥 Erreur update méthode', err);
      console.log('📩 Payload envoyé :', JSON.stringify(dto, null, 2));
    }
  });

  console.groupEnd();
}
getSelectedStepTitlesForVersion(versionControl: AbstractControl): string {
  const version = versionControl as FormGroup;
  const ids: number[] = version.get('stepIds')?.value || [];
  return this.methodSteps
    .filter(step => ids.includes(step.id!))
    .map(step => step.titre)
    .join(', ');
}
  openUpdateModal() {
    this.form.reset();
    this.initializeForm();
    console.log('Opening modal with form:', this.form.value);
    this.modalService.open(this.editModal, { size: 'lg' });
  }
getSelectedStepTitles1(ids: number[]): string {
  if (!ids || !this.methodSteps) return '';
  return this.methodSteps
    .filter(step => ids.includes(step.id!))
    .map(step => step.titre)
    .join(', ');
}
    openEditModal(element: any) {
        console.log(element)
        this.form.patchValue(element);
        this.cdr.detectChanges(); // Force la détection des changements
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'xl'});
    }
  /** Éditer méthode */
editMethode(methode: MethodeDTO) {
  console.log('Éditer méthode :', methode);

  // 1. Vérifier que methodSteps est déjà chargé
  if (!this.methodSteps || this.methodSteps.length === 0) {
    this.fetchMethodSteps(); // Recharge les steps
  }

  // 2. Réinitialiser le formulaire
  this.form.reset();
  this.initializeForm();

  // 3. Patcher les valeurs principales
  this.form.patchValue({
    id: methode.id,
    code: methode.code,
    name: methode.name,
    norme: methode.norme,
    stepIds: methode.stepIds
  });

  // 4. Réinitialiser FormArray versions
  this.versions.clear();
  methode.versions.forEach(v => {
    const group = this.fb.group({
      id: [v.id || null],
      numero: [v.numero ?? 1, [Validators.required]], // 🔹 Attention aux crochets
      description: [v.description || ''],
      dateEdition: [v.dateEdition || ''],
      stepIds: [v.stepIds || []]
    });
    this.versions.push(group);
  });

  // 5. Initialiser l'état des dropdowns pour chaque version
  this.versionDropdownState = this.versions.controls.map(() => false);

  // 6. Forcer la détection des changements pour que Angular mette à jour les inputs
  this.cdr.detectChanges();

  // 7. Ouvrir le modal
  this.modalService.open(this.editModal, { size: 'xl' });
}

getStepTitlesFromIds(ids: number[] = []): string {
  console.group('🔹 getStepTitlesFromIds');
  console.log('💡 IDs reçus :', ids);
  console.log('📦 methodSteps disponibles :', this.methodSteps);

  if (!ids || ids.length === 0 || !this.methodSteps) {
    console.log('⚠️ Aucun ID ou methodSteps vide, retour ""');
    console.groupEnd();
    return '';
  }

  const titles = ids
    .map(id => {
      const step = this.methodSteps.find(s => s.id === id);
      if (!step) {
        console.warn(`⚠️ Aucun step trouvé pour id=${id}`);
        return '';
      }
      console.log(`✅ Step trouvé pour id=${id} : ${step.titre}`);
      return step.titre;
    })
    .filter(Boolean);

  const result = titles.join(', ');
  console.log('🎯 Titres retournés :', result);
  console.groupEnd();
  return result;
}


  /** Supprimer méthode */
  deleteMethode(methode: MethodeDTO) {
    if (confirm(`Voulez-vous vraiment supprimer la méthode "${methode.name}" ?`)) {
      this.methodeService.deleteMethode(methode.id).subscribe({
        next: () => this.fetchMethodes(),
        error: (err) => console.error('Erreur lors de la suppression', err)
      });
    }
  }

  /** Sauvegarder méthode et versions */
  saveMethode() {

  console.group('🚀 saveMethode()');

  // 1️⃣ Vérification du formulaire
  if (this.form.invalid) {
    console.error('❌ Formulaire invalide', this.form);
    console.groupEnd();
    return;
  }

  console.log('📋 Valeur brute du formulaire');
  console.table(this.form.value);

  // 2️⃣ Construction du DTO
const dto: MethodeDTO = {
  id: this.form.value.id || null,
  code: this.form.value.code,
  name: this.form.value.name,
  norme: this.form.value.norme,
  // 🔥 IMPORTANT : stepIds (PAS steps)
  stepIds: this.form.value.stepIds ?? [],

  versions: (this.form.value.versions || []).map((v: any) => ({
    id: v.id || null,
    numero: v.numero,
    description: v.description,
    dateEdition: v.dateEdition,

    // 🔥 IMPORTANT
    stepIds: v.stepIds ?? []
  }))
};

  // 3️⃣ Log final du DTO envoyé au backend
  console.group('📤 DTO ENVOYÉ AU BACKEND');
  console.log(dto);
  console.log('🧾 JSON envoyé :');
  console.log(JSON.stringify(dto, null, 2));
  console.groupEnd();

  // 4️⃣ Appel backend
  this.methodeService.createMethode(dto).subscribe({
    next: (res) => {
      console.group('🎉 RÉPONSE BACKEND');
      console.log('✅ Méthode créée / mise à jour :', res);
      console.log('📦 Versions retournées :', res?.versions);
      console.groupEnd();

      this.modalService.dismissAll();
      this.dialogService.openSuccessDialog(
        'Méthode créé avec succès'
      );
      this.fetchMethodes();
    },
    error: (err) => {
      console.group('🔥 ERREUR BACKEND');
      console.error(err);
      console.log('📩 Payload envoyé qui a causé l’erreur :');
      console.log(JSON.stringify(dto, null, 2));
      console.groupEnd();
    }
  });

  console.groupEnd();
}

}